import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
  InputAdornment,
  IconButton,
} from "@mui/material";
import axios from "axios";
  import { useAlerta } from "utils/alertas";
  import { v4 as uuidv4 } from "uuid";
  import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
  

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};


const EditUserModal = ({ userId, open, onClose, onUpdate }) => {
  const [userData, setUserData] = useState({
    username: "",
    password: "",
  });
  const { mostrarAlerta } = useAlerta();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // Traer datos del usuario cuando cambie userId o se abra el modal
  useEffect(() => {
    if (!userId || !open) return;
    setLoading(true);
    axios
      .get(`/users/${userId}`)
      .then((res) => {
        setUserData({
          username: res.data.ci,
          password: res.data.password_plain ?? Math.random().toString(36).slice(-6)
        });
        console.log(res);
        
      })
      .catch((err) => {
        console.error("Error fetching user:", err);
      })
      .finally(() => setLoading(false));
  }, [userId, open]);

  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    setSaving(true);
    axios
      .put(`/users/${userId}/activate`, userData) // Endpoint para actualizar usuario
      .then((res) => {
        if (onUpdate) onUpdate(res.data); // callback para refrescar tabla o lista
        onClose(); // cerrar modal
        window.location.reload();
        mostrarAlerta("usuario activado correctamente","success");
      })
       
      .catch((err) => {
        console.error("Error updating user:", err);
        alert("Error al actualizar usuario");
      })
      .finally(() => setSaving(false));
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" mb={2}>
          Editar Usuario
        </Typography>

        {loading ? (
          <Box display="flex" justifyContent="center" my={3}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <TextField
              fullWidth
              label="Código del Estudiante (Username)"
              name="username"
              value={userData.username}
              onChange={handleChange}
              margin="normal"
            />
            <TextField
                fullWidth
                label="Contraseña"
                name="password"
                type={showPassword ? "text" : "password"} // alterna entre texto y password
                value={userData.password}
                onChange={handleChange}
                margin="normal"
                InputProps={{
                    endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                        >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                    ),
                }}
                />

            <Box mt={3} display="flex" justifyContent="flex-end" gap={1}>
              <Button
                onClick={onClose}
                variant="outlined"
                sx={{
                  borderColor: "#d32f2f",
                  color: "#d32f2f",
                  "&:hover": {
                    borderColor: "#b71c1c",
                    backgroundColor: "rgba(211,47,47,0.1)",
                  },
                }}
              >
                Cancelar
              </Button>

              <Button
                variant="contained"
                onClick={handleSave}
                disabled={saving}
                sx={{
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#115293",
                  },
                }}
              >
                {saving ? "Guardando..." : "Guardar"}
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default EditUserModal;